import React from 'react';

const SvgSlightlyRoundedCorner = props => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 8a5 5 0 015-5h13v2H8a3 3 0 00-3 3v8a3 3 0 003 3h13v2H8a5 5 0 01-5-5V8z"
      fill="currentColor"
    />
  </svg>
);

export default SvgSlightlyRoundedCorner;
